module.exports = __webpack_public_path__ + "assets/pdf/termos-de-uso.7bf62d9e.pdf";